import {Image, Stack} from '@mantine/core'

import logoColor from 'src/theme/brand/mattech-stacked-flat.png'

import classes from './auth-brand-header.module.css'

export function AuthBrandHeader() {
    return (
        <Stack gap={6} align="flex-start" mb="lg">
            <Image src={logoColor} alt="Mat Tech" w={180} h="auto" fit="contain" />
            <div className={classes['product']}>Depot</div>
        </Stack>
    )
}
